import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getCustomerToken = () => localStorage.getItem("gt_customer_token");
export const setCustomerToken = (t) => localStorage.setItem("gt_customer_token", t);
export const clearCustomerToken = () => localStorage.removeItem("gt_customer_token");

const headers = () => ({ Authorization: `Bearer ${getCustomerToken()}` });

export const accountGet = (path) =>
  axios.get(`${API}${path}`, { headers: headers() }).then((r) => r.data);

export const accountPost = (path, body) =>
  axios.post(`${API}${path}`, body, { headers: headers() }).then((r) => r.data);

export const accountPut = (path, body) =>
  axios.put(`${API}${path}`, body, { headers: headers() }).then((r) => r.data);

export const accountDelete = (path) =>
  axios.delete(`${API}${path}`, { headers: headers() }).then((r) => r.data);

// --- Shared wishlist SKU cache (so catalog cards + product page stay in sync)
let wishlistSkus = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(wishlistSkus));

export const subscribeWishlist = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const refreshWishlist = async () => {
  if (!getCustomerToken()) {
    wishlistSkus = [];
  } else {
    try {
      const me = await accountGet("/account/me");
      wishlistSkus = (me.wishlist || []).map((w) => w.sku);
    } catch {
      wishlistSkus = [];
    }
  }
  notify();
  return wishlistSkus;
};

export const getWishlistSkus = () => wishlistSkus;

export const toggleWishlist = async (sku) => {
  const current = new Set(wishlistSkus || []);
  if (current.has(sku)) {
    await accountDelete(`/account/wishlist/${encodeURIComponent(sku)}`);
    current.delete(sku);
  } else {
    await accountPost("/account/wishlist", { sku });
    current.add(sku);
  }
  wishlistSkus = Array.from(current);
  notify();
  return current.has(sku);
};
